import { useNavigate } from "react-router";
import { Button, Flex, Grid, Paper, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CourseCard } from "../../entities/components/CourseCard";
import Course2 from "../../shared/images/Course-2.png";
import Course1 from "../../shared/images/Course-1.png";
import Course3 from "../../shared/images/Course-3.png";
import { useTranslation } from "react-i18next";
import useCoursesStore from "../../store/useCoursesStore";
import useAuthStore from "../../store/useAuthStore";
import { capitalizeFirstLetter } from "../../utils/helpers";
import { OnboardingTour } from "@gfazioli/mantine-onboarding-tour";

export const RecomendedCourses = () => {
  const laptop = useMediaQuery("(max-width: 1100px)");
  const mobile = useMediaQuery("(max-width: 820px)");
  const matches = useMediaQuery("(max-width: 650px)");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const images = [Course1, Course2, Course3];

  const {
    recommendedCourses,
    learningCourses,
    fetchLearningCourses,
    addLearningCourses,
    removeLearningCourse,
    setCurrentTab,
  } = useCoursesStore();
  const { access_token } = useAuthStore();

  const handleOnClick = async (id: number) => {
    const course = learningCourses.results.find(
      (learningCourse) => learningCourse.course.id === id
    );
    const exist = learningCourses.results.some(
      (learningCourse) => learningCourse.course.id === id
    );

    if (exist && access_token) {
      await removeLearningCourse(course?.id!, id);
      fetchLearningCourses();
    } else if (!exist && access_token) {
      await addLearningCourses(id);
      fetchLearningCourses();
    }
  };

  const handleCategoryClick = (category: string, topic?: string) => {
    const url = topic
      ? `/courses?category=${encodeURIComponent(
          category
        )}&topic=${encodeURIComponent(capitalizeFirstLetter(topic))}`
      : `/courses?category=${encodeURIComponent(category)}`;

    navigate(url);
  };

  if (recommendedCourses.results.length > 0) {
    return matches ? (
      <Paper withBorder radius="24px" p={32} h="100%">
        <OnboardingTour.Target id="dashboard-recommended">
          <Title size={36} mb={40}>
            {t("new_recommended_courses")}
          </Title>
        </OnboardingTour.Target>
        <Grid>
          {recommendedCourses.results.slice(0, 3).map((course, index) => (
            <Grid.Col span={mobile ? 12 : laptop ? 6 : 4} key={index}>
              <CourseCard
                id={course.id}
                image={
                  course.image ? course.image : images[index % images.length]
                }
                platform={course.platform}
                title={course.title}
                authors={course.authors}
                description={course.description}
                rating={course.rating ?? "Unrated"}
                handleOnClick={handleOnClick}
                url={course.url}
                isLearning={course.is_in_learnings}
                category={course.category}
                topics={course.topics}
                languages={course.languages}
                organization={course.organization}
                price={course.price}
                currency={course.currency}
                is_free={course.is_free}
                onCategoryClick={handleCategoryClick}
              />
            </Grid.Col>
          ))}
        </Grid>
        <Flex justify={mobile ? "center" : "flex-start"}>
          <Button
            maw="100%"
            variant="outline"
            mt={24}
            onClick={() => {
              navigate("/courses");
              setCurrentTab("Recommended");
            }}
          >
            {t("view_all_recommended_courses")}
          </Button>
        </Flex>
      </Paper>
    ) : (
      <OnboardingTour.Target id="dashboard-recommended">
        <Paper withBorder radius="24px" p={32} h="100%">
          <Title size={36} mb={40}>
            {t("new_recommended_courses")}
          </Title>
          <Grid>
            {recommendedCourses.results.slice(0, 3).map((course, index) => (
              <Grid.Col span={mobile ? 12 : laptop ? 6 : 4} key={index}>
                <CourseCard
                  id={course.id}
                  image={
                    course.image ? course.image : images[index % images.length]
                  }
                  platform={course.platform}
                  title={course.title}
                  authors={course.authors}
                  description={course.description}
                  rating={course.rating ?? "Unrated"}
                  handleOnClick={handleOnClick}
                  url={course.url}
                  isLearning={course.is_in_learnings}
                  category={course.category}
                  topics={course.topics}
                  languages={course.languages}
                  organization={course.organization}
                  price={course.price}
                  currency={course.currency}
                  is_free={course.is_free}
                  onCategoryClick={handleCategoryClick}
                />
              </Grid.Col>
            ))}
          </Grid>
          <Flex justify={mobile ? "center" : "flex-start"}>
            <Button
              maw="100%"
              variant="outline"
              mt={24}
              onClick={() => {
                navigate("/courses");
                setCurrentTab("Recommended");
              }}
            >
              {t("view_all_recommended_courses")}
            </Button>
          </Flex>
        </Paper>
      </OnboardingTour.Target>
    );
  } else {
    return (
      <OnboardingTour.Target id="dashboard-recommended">
        <Paper withBorder radius="24px" p={32} h="100%">
          <Title size={36} mb={40}>
            {t("new_recommended_courses_loading")}
          </Title>
        </Paper>
      </OnboardingTour.Target>
    );
  }
};
